import { useState } from 'react';
import { latestAddresses, faqItems, articles as allArticles } from '@/mocks/data';
import type { Article } from '@/mocks/data';
import SchemaOrg from '@/components/feature/SchemaOrg';

export default function HeroSection() {
  const [copiedIndex, setCopiedIndex] = useState<number | null>(null);

  const handleCopy = (url: string, index: number) => {
    navigator.clipboard.writeText(url).then(() => {
      setCopiedIndex(index);
      setTimeout(() => setCopiedIndex(null), 2000);
    });
  };

  return (
    <section className="relative w-full min-h-[580px] md:min-h-[680px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20minimalist%20community%20hub%20concept%2C%20abstract%20geometric%20network%20nodes%20connected%20with%20soft%20glowing%20lines%2C%20cream%20and%20warm%20beige%20gradient%20background%2C%20subtle%20texture%2C%20clean%20modern%20digital%20art%2C%20peaceful%20and%20trustworthy%20atmosphere&width=1600&height=900&seq=hero-bg-2026&orientation=landscape"
          alt="caoliushequ官方导航"
          className="w-full h-full object-cover"
          title="caoliushequ官方入口导航"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/45" />

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <p className="text-accent-400 text-sm md:text-base font-medium mb-3 tracking-wider">
          caoliushequ 官方认证导航站
        </p>
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading text-background-50 mb-6 leading-tight">
          caoliushequ 官方入口
          <br />
          <span className="text-accent-400">最新地址发布</span>
        </h1>
        <p className="text-background-200 text-base md:text-lg max-w-2xl mx-auto mb-10 leading-relaxed">
          caoliushequ是深受用户喜爱的内容社区平台。本页提供caoliushequ最新可用地址、访问指南及常见问题解答，帮助您快速找到caoliushequ官方入口，畅享完整社区体验。
        </p>

        <div className="bg-background-50/95 backdrop-blur-sm rounded-2xl p-5 md:p-8 max-w-xl mx-auto">
          <h2 className="text-lg font-heading text-foreground-900 mb-5 flex items-center justify-center gap-2">
            <i className="ri-links-line text-primary-500" />
            caoliushequ 最新可用地址
          </h2>
          <div className="flex flex-col gap-3">
            {latestAddresses.map((addr, index) => (
              <div
                key={index}
                className="flex items-center justify-between bg-background-100 rounded-lg px-4 py-3 transition-colors"
              >
                <div className="flex items-center gap-3">
                  <span className={`w-2 h-2 rounded-full ${addr.type === 'primary' ? 'bg-primary-500' : addr.type === 'mobile' ? 'bg-accent-500' : 'bg-secondary-500'}`} />
                  <div className="text-left">
                    <span className="text-xs text-foreground-500 block">{addr.label}</span>
                    <span className="text-sm font-medium text-foreground-800">{addr.url}</span>
                  </div>
                </div>
                <button
                  onClick={() => handleCopy(addr.url, index)}
                  className="flex items-center gap-1.5 px-3 py-1.5 rounded-md text-xs font-medium bg-primary-50 text-primary-600 hover:bg-primary-100 transition-colors whitespace-nowrap cursor-pointer"
                >
                  <i className={`text-sm ${copiedIndex === index ? 'ri-check-line' : 'ri-file-copy-line'}`} />
                  {copiedIndex === index ? '已复制' : '复制'}
                </button>
              </div>
            ))}
          </div>
          <p className="text-xs text-foreground-400 mt-4">
            建议将本页添加至浏览器书签，随时获取 caoliushequ 最新地址
          </p>
        </div>
      </div>
    </section>
  );
}

export function FeatureSection() {
  const features = [
    { icon: 'ri-shield-check-line', title: '官方认证', desc: '全部地址经caoliushequ官方验证发布，确保安全可靠' },
    { icon: 'ri-refresh-line', title: '实时更新', desc: '地址变更时第一时间更新，保证信息的时效性' },
    { icon: 'ri-smartphone-line', title: '全端适配', desc: '支持PC端和移动端访问，自动适配不同设备屏幕' },
    { icon: 'ri-customer-service-2-line', title: '贴心服务', desc: '提供详细访问教程和常见问题解答，新用户也能轻松上手' },
  ];

  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">
            为什么选择 caoliushequ 官方导航站？
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            作为caoliushequ唯一官方认证的地址发布平台，我们致力于为用户提供最可靠的访问服务
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {features.map((f, i) => (
            <div key={i} className="bg-background-100 rounded-xl p-6 text-center group hover:bg-background-200 transition-colors">
              <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-full bg-primary-50 text-primary-500">
                <i className={`${f.icon} text-xl`} />
              </div>
              <h3 className="text-base font-semibold text-foreground-800 mb-2">{f.title}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export function GuideSection() {
  const steps = [
    { step: '01', title: '获取最新地址', desc: '在本导航页查看caoliushequ当前最新可用地址，选择任一地址复制' },
    { step: '02', title: '打开浏览器', desc: '将复制的地址粘贴到浏览器地址栏，访问caoliushequ官方入口' },
    { step: '03', title: '注册/登录账号', desc: '首次访问请注册账号，已有账号直接登录即可畅享社区' },
    { step: '04', title: '开始探索', desc: '浏览各板块内容，参与讨论互动，开启caoliushequ社区之旅' },
  ];

  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">
            caoliushequ 访问指南
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            只需简单四步，即可快速访问caoliushequ，开始您的社区之旅
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {steps.map((s, i) => (
            <div key={i} className="relative">
              <div className="bg-background-50 rounded-xl p-6 text-center">
                <span className="text-3xl font-heading text-primary-500/30 block mb-3">{s.step}</span>
                <h3 className="text-base font-semibold text-foreground-800 mb-2">{s.title}</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">{s.desc}</p>
              </div>
              {i < steps.length - 1 && (
                <div className="hidden lg:block absolute top-1/2 -right-3 transform -translate-y-1/2 text-foreground-300">
                  <i className="ri-arrow-right-line text-xl" />
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggle = (i: number) => setOpenIndex(openIndex === i ? null : i);

  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto">
        <SchemaOrg type="FAQPage" faqItems={faqItems} />
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">
            caoliushequ 常见问题
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">
            我们整理了用户最关心的问题，帮助您快速找到答案
          </p>
        </div>
        <div className="flex flex-col gap-3">
          {faqItems.map((item, i) => (
            <div
              key={i}
              className="bg-background-100 rounded-xl overflow-hidden transition-colors"
            >
              <button
                onClick={() => toggle(i)}
                className="w-full flex items-center justify-between px-6 py-4 text-left cursor-pointer"
              >
                <h4 className="text-sm md:text-base font-medium text-foreground-800 pr-4">
                  <a href={`#faq-${i}`} className="hover:text-primary-500 transition-colors">
                    {item.question}
                  </a>
                </h4>
                <div className={`w-6 h-6 flex items-center justify-center flex-shrink-0 transition-transform duration-300 ${openIndex === i ? 'rotate-45' : ''}`}>
                  <i className="ri-add-line text-foreground-500" />
                </div>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === i ? 'max-h-96 pb-5' : 'max-h-0'
                }`}
              >
                <p className="px-6 text-sm text-foreground-600 leading-relaxed">
                  {item.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
        <div className="text-center mt-8">
          <a href="/category/faq" className="inline-flex items-center gap-1.5 text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors whitespace-nowrap cursor-pointer">
            查看更多问题解答
            <i className="ri-arrow-right-line" />
          </a>
        </div>
      </div>
    </section>
  );
}

export function FeaturedArticles() {
  const featured = allArticles.slice(0, 3);

  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-2">
              精选文章
            </h2>
            <p className="text-foreground-500 text-sm">
              caoliushequ官方发布的最新资讯和使用指南
            </p>
          </div>
          <a href="/category/latest-address" className="hidden sm:inline-flex items-center gap-1.5 text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors whitespace-nowrap cursor-pointer">
            查看全部文章
            <i className="ri-arrow-right-line" />
          </a>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {featured.map((article: Article) => (
            <a
              key={article.id}
              href={`/article/${article.id}`}
              className="group bg-background-100 rounded-xl overflow-hidden hover:bg-background-200 transition-colors block cursor-pointer"
            >
              <div className="h-48 overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  title={`${article.title} - caoliushequ`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-2 mb-2 flex-wrap">
                  <span className="text-xs px-2 py-0.5 rounded-full bg-primary-50 text-primary-600">{article.category}</span>
                  <span className="text-xs text-foreground-400">{article.publishDate}</span>
                </div>
                <h3 className="text-base font-semibold text-foreground-800 mb-2 line-clamp-2 group-hover:text-primary-500 transition-colors">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-500 line-clamp-2 leading-relaxed mb-3">
                  {article.summary}
                </p>
                <div className="flex items-center gap-4 text-xs text-foreground-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line" /> {article.readCount.toLocaleString()}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-chat-3-line" /> {article.commentCount.toLocaleString()}
                  </span>
                </div>
              </div>
            </a>
          ))}
        </div>
        <div className="text-center mt-8 sm:hidden">
          <a href="/category/latest-address" className="inline-flex items-center gap-1.5 text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors whitespace-nowrap cursor-pointer">
            查看全部文章
            <i className="ri-arrow-right-line" />
          </a>
        </div>
      </div>
    </section>
  );
}